import "../../css/userPage/PaymentHistory.css"
import { useState } from "react";
import PaymentList from "./PaymentList";

let PaymentHistoryPage = (props) => {
    let [currentPage, setCurrentPage] = useState(1)
    let [needUpdate, setNeedUpdate] = useState(false)

    return (
        <div className="content-container">
            <div className="payment-history-page-header">
                <div className="title-selector-container">
                    <div className="payment-history-page-title-container">
                        <p className="content-title">결제 내역</p>
                    </div>
                    <div className="holding-cancel-guide">
                        <p>대기중인 홀딩 옆의 <span className="cancel-button-example">x</span> 버튼을 클릭하면 홀딩 신청을 취소할 수 있습니다.</p>
                    </div>
                </div>
            </div>
            <div className="payment-history-scroll-container">
                <PaymentList 
                    needUpdate={needUpdate}
                    setNeedUpdate={setNeedUpdate}
                    currentPage={currentPage}
                    onCurrentPageChange={(page) => setCurrentPage(page)}
                    onUpdate={() => setNeedUpdate(false)}
                />
            </div>
        </div>
    );
}

export default PaymentHistoryPage;